import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getZoneParams, setZoneParams } from '@blade-sxp/account/api/params-setting';
let default_1 = class extends Vue {
    loading = false;
    fromData = {
        blue: { minRange: 0, maxRange: undefined, color: 'blue' },
        yellow: { minRange: undefined, maxRange: undefined, color: 'yellow' },
        red: { minRange: undefined, maxRange: undefined, color: 'red' },
    };
    response = {};
    rules = {
        blue: [{
                required: true,
                trigger: blur,
                validator: (rule, value, callback) => {
                    if (!this.fromData.blue.maxRange)
                        return callback(new Error(this.$t('inputError').toString()));
                    callback();
                },
            }],
        yellow: [{
                required: true,
                trigger: blur,
                validator: (rule, value, callback) => {
                    const data = this.fromData.yellow;
                    if (!data.maxRange || !data.minRange || data.maxRange <= data.minRange)
                        return callback(new Error(this.$t('inputError').toString()));
                    callback();
                },
            }],
        red: [{
                required: true,
                trigger: blur,
                validator: (rule, value, callback) => {
                    const data = this.fromData.red;
                    if (!data.maxRange || !data.minRange || data.maxRange <= data.minRange)
                        return callback(new Error(this.$t('inputError').toString()));
                    callback();
                },
            }],
    };
    onBlueDataChange() {
        this.fromData.yellow.minRange = (this.fromData.blue.maxRange ?? 0) + 1;
    }
    onYellowDataChange() {
        this.fromData.red.minRange = (this.fromData.yellow.maxRange ?? 0) + 1;
    }
    handleSubmit() {
        const form = this.$refs.colorForm;
        form.validate((valid) => {
            if (valid) {
                this.loading = true;
                const { blue, yellow, red } = this.fromData;
                const req = { colorList: [blue, yellow, red], zoneResetTime: this.response?.zoneResetTime };
                setZoneParams(req).then(resp => {
                    this.$message({ type: 'success', message: resp?.data?.message || '' });
                }).catch(error => {
                    this.$message({ type: 'error', message: error });
                }).finally(() => {
                    this.loading = false;
                });
            }
        });
    }
    mounted() {
        getZoneParams().then((resp) => {
            this.response = resp.data?.data || {};
            const colorList = this.response.colorList || [];
            const [blue, yellow, red] = colorList;
            if (blue)
                this.fromData.blue = blue;
            if (yellow)
                this.fromData.yellow = yellow;
            if (red)
                this.fromData.red = red;
        }).catch(error => {
            this.$message({ type: 'error', message: error });
        });
    }
};
default_1 = __decorate([
    Component({
        name: 'HeatMap',
        i18n: {
            messages: {
                zh: {
                    heatMap: '人流洞察大屏热力区间值：',
                    blueTip: '蓝色区间',
                    yellowTip: '黄色区间',
                    redTip: '红色区间',
                    submit: '提交',
                    inputError: '请输入正确的数字',
                    placeholder: '请输入',
                },
                'en-us': {
                    heatMap: 'Value range of thermodynamic diagram：',
                    blueTip: 'Blue',
                    yellowTip: 'Yellow',
                    redTip: 'Red',
                    submit: 'Submit',
                    inputError: 'Please enter the correct number',
                    placeholder: 'Please input',
                },
            },
        },
    })
], default_1);
export default default_1;
